/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Content partner identifiers for Smart Tag
 * Used for partner-specific CSS, features, and configurations.
 * Values correspond to paramsVO.CONTENT.partner
 *
 * @example
 * // Usage in params:
 * params: {
 *   CONTENT: {
 *     partner: Partner.PTV  // Loads PTV-specific CSS
 *   }
 * }
 *
 * @note This enum {Partner} is separate from FreewheelPartner {FreewheelPartner} for important reasons:
 * 1. Different purposes: Content delivery vs Ad targeting
 * 2. Different values: Partner.PARAMOUNT_PLUS = 'pplus' vs FreewheelPartner.PARAMOUNT_PLUS = 'paramountplus'
 * 3. Different sources: Set by page/client vs Determined by domain check
 * 4. Different usage: Smart Tag features vs Freewheel ad calls
 *
 * @see {@link FreewheelPartner} For Freewheel ad call partner identifiers (different values!)
 */
export enum Partner {
	/**
	 * @description CBS - Default content partner
	 */
	CBS = 'cbs',

	/**
	 * @description PTV - Paramount Television content partner
	 */
	PTV = 'plutotv',

	/**
	 * @description Paramount Plus content partner
	 */
	PARAMOUNT_PLUS = 'pplus',
}